<template>
    <el-dialog title="Bouteille" :visible.sync="thisvisible">
        <div class="form-container">
            <div v-loading="loading" class="form-container">
                <el-form
                    ref="bouteilleForm"
                    :model="bouteille"
                    :rules="rules"
                    label-position="left"
                    label-width="150px"
                    style="max-width: 500px;"
                >
                    <el-form-item
                        label="Millésime"
                        prop="millesime"
                        :error="getErrorForField('millesime', errors)"
                    >
                        <el-date-picker
                            value-format="yyyy"
                            type="year"
                            v-model="thisbouteille.millesime"
                        />
                    </el-form-item>
                    <el-form-item label="État" prop="etat">
                        <el-select
                            v-model="thisbouteille.etat"
                            placeholder="Select"
                        >
                            <el-option
                                v-for="etat in etats"
                                :key="etat.value"
                                :label="etat.label"
                                :value="etat.value"
                            />
                        </el-select>
                    </el-form-item>
                     <el-form-item label="Allocation" prop="allocation">
                        <el-select
                            v-model="thisbouteille.allocation_id"
                            placeholder="Select"
                        >
                            <el-option
                                v-for="allocation in allocations"
                                :key="allocation.id"
                                :label="allocation.nom"
                                :value="allocation.id"
                            />
                        </el-select>
                    </el-form-item>
                   <el-form-item
                        label="Prix HT"
                        prop="prix"
                        type="number"
                        :error="getErrorForField('prix', errors)"
                    >
                        <el-input
                            v-model="thisbouteille.prix"
                            @input="changeprix('fromht')"
                        />
                    </el-form-item>
                    <el-form-item label="Prix TTC" prop="prixttc" type="number">
                        <el-input
                            v-model="thisbouteille.prixttc"
                            @input="changeprix('fromttc')"
                        />
                    </el-form-item>
                     <el-form-item
                        label="Magnum"
                        prop="ismagnum"
                        type="number"
                        >
                        <el-checkbox
                            false-label="0"
                            true-label="1"
                            v-model="thisbouteille.ismagnum"
                        />
                    </el-form-item>
                    <el-form-item
                        label="Max"
                        prop="max"
                        type="number">
                        <el-input
                            v-model="thisbouteille.max"
                        />
                    </el-form-item>
                   <el-form-item
                        label="Stock"
                        prop="stock"
                        :error="getErrorForField('stock', errors)"
                    >
                        <el-input v-model="thisbouteille.stock" />
                    </el-form-item>
                    <template v-if="thisbouteille.id">
                        <el-form-item
                            v-for="field in fieldsPhoto"
                            :key="field"
                            :label="labels[field]"
                            :prop="field"
                        >
                            <div v-if="thisbouteille[field] && !replace[field]">
                                <el-image
                                    class="userimage"
                                    :src="thisbouteille[field + '_url'].mini"
                                    fit="cover"
                                />
                                <div class="controls">
                                    <el-link
                                        type="primary"
                                        icon="el-icon-refresh"
                                        :underline="false"
                                        @click="
                                            replace[field] = !replace[field]
                                        "
                                    />
                                    <el-link
                                        type="danger"
                                        icon="el-icon-delete"
                                        :underline="false"
                                        @click="handleDeletePhoto(field)"
                                    />
                                </div>
                            </div>
                            <el-upload
                                v-else
                                drag
                                :action="
                                    '/api/bouteilles/' +
                                        thisbouteille.id +
                                        '/files'
                                "
                                :on-success="
                                    (res, file, fileList) =>
                                        handleSucess(res, file, fileList, field)
                                "
                                :headers="headers"
                                :on-error="handleError"
                                :file-list="fileList"
                                :name="field"
                            >
                                <i class="el-icon-upload" />
                                <div class="el-upload__tip">
                                    jpg
                                </div>
                                <div
                                    v-if="replace[field]"
                                    slot="tip"
                                    class="el-upload__tip cursopointer"
                                    @click="replace[field] = !replace[field]"
                                >
                                    Annuler
                                </div>
                            </el-upload>
                        </el-form-item>
                    </template>
                    <el-form-item>
                        <el-button type="info" @click="thisvisible = false">
                            Annuler
                        </el-button>
                        <el-button type="primary" @click="save">
                            Enregistrer
                        </el-button>
                        <el-button
                            v-if="thisbouteille.id"
                            type="danger"
                            @click="supprimer"
                        >
                            Supprimer
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Resource from "@/api/resource";
import { getToken } from "@/utils/auth";

const bouteilleResource = new Resource("bouteilles");

export default {
    name: "Bouteille",
    props: {
        isvisible: {
            type: Boolean,
            default: false
        },
        bouteille: {
            type: Object,
            default: () => {
                return {
                    millesime: "2000",
                    etat: "masqued",
                    description: "",
                    photo: "",
                    photo_back: "",
                    stock: 0,
                    prix: 0,
                    prixttc: 0
                };
            }
        },
        parent: {
            type: Object
        },
        allocations: {
            type: Array
        }
    },
    data() {
        return {
            thisvisible: false,
            loading: false,
            rules: {},
            errors: [],
            fileList: [],
            headers: {
                Authorization: "Bearer " + getToken()
            },
            // fieldsPhoto: ["photo", "photo_back"],
            fieldsPhoto: ["photo"],
            replace: {
                photo: false,
                photo_back: false
            },
            labels: {
                photo: "photo face",
                photo_back: "photo dos"
            },
            thisbouteille: {
                millesime: "2000",
                max: 8,
                ismagnum: false,
                description: "",
                photo: "",
                photo_back: "",
                etat: "masqued",
                stock: 0,
                prix: 0,
                prixttc: 0
            },
            etats: [
                { value: "envente", label: "En vente" },
                { value: "epuise", label: "Épuisé" },
                { value: "masqued", label: "Masqué" }
            ]
        };
    },
    watch: {
        isvisible(val) {
            if (val) {
                this.thisvisible = val;
                this.errors = [];
                if (this.bouteille) {
                    Object.assign(this.thisbouteille, this.bouteille);
                }
            }
        },
        thisvisible(val) {
            if (!val) {
                this.parent.dialogBouteilleVisible = val;
                this.errors = [];
            }
        }
    },
    computed: {},
    methods: {
        changeprix(from) {
            console.log("change " + from);
            if (from == "fromttc") {
                this.thisbouteille.prix =
                    Math.round((this.thisbouteille.prixttc / 1.2) * 100) / 100;
            } else {
                this.thisbouteille.prixttc =
                    Math.round(this.thisbouteille.prix * 1.2 * 100) / 100;
            }
        },
        handleSucess(response, file, fileList, col) {
            //var col = 'photo';
            console.log(response);
            console.log(file);
            console.log(fileList);
            console.log("col es" + col);
            if (response.data) {
                this.thisbouteille[col] = response.data[col];
                this.thisbouteille[col + "_url"] = response.data[col + "_url"];
                this.bouteille[col] = response.data[col];
                this.bouteille[col + "_url"] = response.data[col + "_url"];
                this.replace[col] = false;
            } else if (response.error) {
                this.$message({
                    type: "error",
                    message: response.error,
                    duration: 1 * 5000
                });
            }
        },
        handleError(err) {
            this.$message({
                type: "error",
                message: err,
                duration: 1 * 5000
            });
        },
        handleDeletePhoto(col) {
            console.log("del" + col);
            this.$confirm("Voulez-vous supprimer cette photo ?", "Attention", {
                confirmButtonText: "OUI",
                cancelButtonText: "Annuler",
                type: "warning"
            })
                .then(() => {
                    this.bouteille[col] = null;
                    this.bouteille[col + "_url"] = null;
                    this.thisbouteille[col] = null;
                    this.thisbouteille[col + "_url"] = null;
                    this.save();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "Suppression annulée"
                    });
                });
        },
        save() {
            this.errors = [];
            this.loading = true;
            if (this.thisbouteille.id) {
                bouteilleResource
                    .update(this.thisbouteille.id, this.thisbouteille)
                    .then(response => {
                        this.loading = false;
                        this.thisvisible = false;
                        this.parent.callbackBouteille(false, response.data);
                        this.$message({
                            message: "Bouteille mise à jour",
                            type: "success",
                            duration: 5 * 1000
                        });
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            } else {
                bouteilleResource
                    .store(this.thisbouteille)
                    .then(response => {
                        this.loading = false;
                        this.thisvisible = false;
                        this.$message({
                            message: "Bouteille créée",
                            type: "success",
                            duration: 5 * 1000
                        });
                        console.log(response);
                        this.parent.callbackBouteille(true, false);
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            }
        },
        supprimer() {
            this.$confirm(
                "Voulez-vous supprimer cette bouteille",
                "Attention",
                {
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Anuler",
                    type: "warning"
                }
            )
                .then(() => {
                    this.loading = true;
                    bouteilleResource
                        .destroy(this.thisbouteille.id)
                        .then(response => {
                            console.log(response);
                            this.loading = false;
                            this.thisvisible = false;
                            this.$message({
                                type: "success",
                                message: "Suppression effectuée"
                            });
                            this.parent.callbackBouteille(true, false);
                        })
                        .catch(error => {
                            console.log(error);
                            this.loading = false;
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "Suppression Anulée"
                    });
                });
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        }
    }
};
</script>
